import React from 'react'
import { DragLayer } from 'react-dnd'
import { compose } from 'ramda'

import { withTheme } from 'modules/util'

import layerTheme from './theme.scss'

function getItemStyles({ currentOffset }) {
  if (!currentOffset) {
    return { display: 'none' }
  }

  const { x, y } = currentOffset
  const transform = `translate(${x}px, ${y}px)`

  return { transform, WebkitTransform: transform }
}

function DraggableIconLayer({ theme, iconSrc, ...props }) {
  return (
    <div className={theme.layer}>
      <div className={theme.layerItem} style={getItemStyles(props)}>
        <img className={theme.layerIcon} role='presentation' src={iconSrc} />
      </div>
    </div>
  )
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  }
}

export default compose(
  withTheme(layerTheme),
  DragLayer(collect)
)(DraggableIconLayer)



// WEBPACK FOOTER //
// ./client/modules/debate/components/Builder/DraggableIconLayer/index.js